/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateReportResponse } from '../models/CreateReportResponse';
import type { GetEntitiesResponse } from '../models/GetEntitiesResponse';
import type { GetEntityResponse } from '../models/GetEntityResponse';
import type { GetReportsResponse } from '../models/GetReportsResponse';
import type { GetReportSummaryResponse } from '../models/GetReportSummaryResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class DefaultService {
    constructor(public readonly http: HttpClient) {}
    /**
     * gets entities for a district
     * @param fid
     * @param entity
     * @param limit
     * @param offset
     * @param filter
     * @returns GetEntitiesResponse the entities for the district
     * @throws ApiError
     */
    public getEntities(
        fid: string,
        entity: 'users' | 'orgs' | 'academicSessions' | 'enrollments' | 'courses' | 'classes' | 'demographics',
        limit: number = 100,
        offset?: number,
        filter?: string,
    ): Observable<GetEntitiesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/entities/{entity}',
            path: {
                'fid': fid,
                'entity': entity,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'filter': filter,
            },
        });
    }
    /**
     * gets an entity for a district
     * @param fid
     * @param entity
     * @param sourcedId
     * @returns GetEntityResponse the entity
     * @throws ApiError
     */
    public getEntity(
        fid: string,
        entity: 'users' | 'orgs' | 'academicSessions' | 'enrollments' | 'courses' | 'classes' | 'demographics',
        sourcedId: string,
    ): Observable<GetEntityResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/entities/{entity}/{sourcedId}',
            path: {
                'fid': fid,
                'entity': entity,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * creates a report for a district
     * @param fid
     * @returns CreateReportResponse the reports for the district
     * @throws ApiError
     */
    public createReport(
        fid: string,
    ): Observable<CreateReportResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/fids/{fid}/reports',
            path: {
                'fid': fid,
            },
        });
    }
    /**
     * gets reports for a district
     * @param fid
     * @returns GetReportsResponse the reports for the district
     * @throws ApiError
     */
    public getReports(
        fid: string,
    ): Observable<GetReportsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/reports',
            path: {
                'fid': fid,
            },
        });
    }
    /**
     * gets a report summary for a district
     * @param fid
     * @param reportId
     * @param product
     * @returns GetReportSummaryResponse the report summary
     * @throws ApiError
     */
    public getReportSummary(
        fid: string,
        reportId: number,
        product?: 'aichat' | 'aware' | 'classroom' | 'discern' | 'home' | 'filter' | 'rhithm' | 'pass' | 'flex' | 'oncall' | 'reveal',
    ): Observable<GetReportSummaryResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/reports/{reportId}/summary',
            path: {
                'fid': fid,
                'reportId': reportId,
            },
            query: {
                'product': product,
            },
        });
    }
    /**
     * gets a report details CSV for a district
     * @param fid
     * @param reportId
     * @param product
     * @returns binary the report details CSV
     * @throws ApiError
     */
    public getReportDetailsCsv(
        fid: string,
        reportId: number,
        product?: 'aichat' | 'aware' | 'classroom' | 'discern' | 'home' | 'filter' | 'rhithm' | 'pass' | 'flex' | 'oncall' | 'reveal',
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/reports/{reportId}/details.csv',
            path: {
                'fid': fid,
                'reportId': reportId,
            },
            query: {
                'product': product,
            },
        });
    }
}
